import DefaultTotalAdjustmentAmountCalculator from "./DefaultTotalAdjustmentAmountCalculator";

export default class DefaultTotalAdjustmentAmountCalculatorFactory {
    private static readonly INSTANCE = new DefaultTotalAdjustmentAmountCalculator();
    public static getInstance() {
        return this.INSTANCE;
    }
}
